import {
    Layers, Activity, ArrowUpFromLine, ShieldCheck,
    Hexagon, CheckCircle2, FolderOpen, Sparkles, Radio,
} from "lucide-react";

/**
 * Category icon factory for notifications. NOT a bell.
 * Each icon is a cinematic line-art style aligned to V3 brand.
 *
 * type → component
 */
const MAP = {
    rendering_complete:           Layers,
    progression_milestone:        Activity,
    upload_complete:              ArrowUpFromLine,
    entitlement_activated:        ShieldCheck,
    smithers_prompt:              Hexagon,
    payment_success:              CheckCircle2,
    module_subscription_activated: Sparkles,
    project_synced:               FolderOpen,
    system_message:               Radio,
};

export default function NotificationIcon({ type, size = 18, className = "" }) {
    const Cmp = MAP[type] || Radio;
    return <Cmp size={size} strokeWidth={1.5} className={className} />;
}
